module.exports = __webpack_public_path__ + "static/media/purchase_order.252aee95.svg";